export function computeAvgSessionMs(sessions) {
  if (!sessions || sessions.length === 0) return 0;

  let total = 0;
  for (const session of sessions) {
    let sessionMs = (session.pageViews || []).reduce(
      (sum, pv) => sum + (pv.durationMs || 0),
      0
    );
    if (sessionMs === 0 && session.start && session.end) {
      sessionMs = new Date(session.end) - new Date(session.start);
    }
    total += sessionMs;
  }

  return total / sessions.length;
}
